import { type CardBrand } from '@stripe/stripe-js';

import visaLogoPath from '@/assets/paymentMethods/visa.svg';
import mastercardLogoPath from '@/assets/paymentMethods/mastercard.svg';
import amexLogoPath from '@/assets/paymentMethods/amex.svg';
import unknownLogoPath from '@/assets/paymentMethods/unknown.svg';
import dinersClubLogoPath from '@/assets/paymentMethods/dinersclub.svg';
import discoverLogoPath from '@/assets/paymentMethods/discover.svg';
import eftposLogoPath from '@/assets/paymentMethods/eftpos.svg';
import jcbLogoPath from '@/assets/paymentMethods/jcb.svg';
import unionPayLogoPath from '@/assets/paymentMethods/unionpay.svg';

import { type CardBrandFormatting } from '@/types/billing';
import { InvoiceStatus, TransactionType } from '@electricjs/core_entity-client';

const paymentMethodDisplayValues: Record<
  CardBrand | 'bank',
  CardBrandFormatting
> = {
  visa: {
    label: 'Visa',
    imagePath: visaLogoPath,
  },
  mastercard: {
    label: 'Mastercard',
    imagePath: mastercardLogoPath,
  },
  amex: {
    label: 'Amex',
    imagePath: amexLogoPath,
  },
  diners: {
    label: 'Diners',
    imagePath: dinersClubLogoPath,
  },
  discover: {
    label: 'Discover',
    imagePath: discoverLogoPath,
  },
  eftpos_au: {
    label: 'Eftpos',
    imagePath: eftposLogoPath,
  },
  jcb: {
    label: 'JCB',
    imagePath: jcbLogoPath,
  },
  unionpay: {
    label: 'UnionPay',
    imagePath: unionPayLogoPath,
  },
  bank: {
    label: 'Bank',
    imagePath: '',
  },
  unknown: {
    label: 'Unknown',
    imagePath: unknownLogoPath,
  },
};

export const getPaymentMethodDisplayValues = (
  brandSlug: CardBrand | 'bank'
): CardBrandFormatting => {
  return (
    paymentMethodDisplayValues[brandSlug] || {
      label: brandSlug,
      imagePath: unknownLogoPath,
    }
  );
};

export const transactionTypeDisplayName: Record<TransactionType, string> = {
  [TransactionType.Subscription]: 'Subscription & add-ons',
  [TransactionType.AdhocInvoice]: 'International hardware purchases',
  [TransactionType.HardwarePurchase]: 'Hardware purchases & shipping',
  [TransactionType.Charge]: 'Miscellaneous',
};

export const invoiceStatusDisplayText: Record<InvoiceStatus, string> = {
  [InvoiceStatus.Paid]: 'Paid',
  [InvoiceStatus.Open]: 'Open',
  [InvoiceStatus.Draft]: 'Draft',
  [InvoiceStatus.Uncollectible]: 'Uncollectible',
  [InvoiceStatus.Void]: 'Void',
};

export const getInvoiceStatusDisplayName = (status: InvoiceStatus): string => {
  const statusMap: Record<InvoiceStatus, string> = {
    [InvoiceStatus.Paid]: 'Paid',
    [InvoiceStatus.Open]: 'Open',
    [InvoiceStatus.Draft]: 'Draft',
    [InvoiceStatus.Uncollectible]: 'Uncollectible',
    [InvoiceStatus.Void]: 'Void',
  };
  return statusMap[status];
};
